module.exports = __webpack_public_path__ + "static/media/jpg.d4716313.svg";